import { PayloadAction } from "@reduxjs/toolkit";

export type AssetTreeSelectionState = {
  selectedCategories: string[];
  selectedClients: string[];
  selectedContracts: string[];
  selectedVehicles: string[];
};

export const criarEstadoDeSelecaoDaArvore = (): AssetTreeSelectionState => ({
  selectedCategories: [],
  selectedClients: [],
  selectedContracts: [],
  selectedVehicles: [],
});

export const assetTreeSelectionReducers = {
  setSelectedCategories: (state: AssetTreeSelectionState, action: PayloadAction<string[]>) => {
    state.selectedCategories = action.payload;
  },
  setSelectedClients: (state: AssetTreeSelectionState, action: PayloadAction<string[]>) => {
    state.selectedClients = action.payload;
  },
  setSelectedContracts: (state: AssetTreeSelectionState, action: PayloadAction<string[]>) => {
    state.selectedContracts = action.payload;
  },
  setSelectedVehicles: (state: AssetTreeSelectionState, action: PayloadAction<string[]>) => {
    state.selectedVehicles = action.payload;
  },
};
